<!-- Small grey label above a section: the style of Settings' Email / Time Zone / Videos titles -->

<template>
  <div class="title"><slot /></div>
</template>

<style scoped>
.title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: rgba(0, 0, 0, 0.35);
  margin: 6px 0 5px 0;
}
</style>
